import { useEffect, useRef } from 'react';

/**
 * Fires `onLoadMore` when the sentinel scrolls into view. rootMargin pre-loads a screen early
 * so the grid never shows a gap while the next page is in flight.
 */
export function useInfiniteScroll(
  onLoadMore: () => void,
  { enabled, loading }: { enabled: boolean; loading: boolean },
) {
  const sentinel = useRef<HTMLDivElement>(null);
  const cb = useRef(onLoadMore);
  cb.current = onLoadMore;

  useEffect(() => {
    const el = sentinel.current;
    if (!el || !enabled || loading) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) cb.current();
      },
      { rootMargin: '600px 0px' },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [enabled, loading]);

  return sentinel;
}
